module.exports = __webpack_public_path__ + "img/outline_account_circle_black_24dp.f87b34c0.png";